"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodAdapter = void 0;
var foundation_1 = require("@deqo/foundation");
var EventSourceBase_1 = require("../streaming/EventSourceBase");
var Codes_1 = require("./Codes");
var logger = foundation_1.Logger.get('podopolis.stats');
var PodAdapter = /** @class */ (function (_super) {
    __extends(PodAdapter, _super);
    function PodAdapter(id, clientId, bridge) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.clientId = clientId;
        _this.bridge = bridge;
        _this.currentTag = 100;
        _this.stagedMessages = [];
        _this.reduceTracker = new Set();
        _this.handlers = {};
        _this.burden(function () { return _this.handlers = {}; });
        return _this;
    }
    PodAdapter.prototype.destroy = function (reason) {
        if (this.destroyed())
            return;
        var final = this.createAsRouter();
        _super.prototype.destroy.call(this);
        this.bridge.requestDestroy();
        final.emit('destroy', reason !== null && reason !== void 0 ? reason : 'unknown');
        final.destroy();
    };
    PodAdapter.prototype.push = function (msg) {
        var e_1, _a;
        var hb = this.handlers[msg[1]];
        if (!hb)
            return;
        try {
            for (var hb_1 = __values(hb), hb_1_1 = hb_1.next(); !hb_1_1.done; hb_1_1 = hb_1.next()) {
                var mh = hb_1_1.value;
                if (mh(msg)) {
                    this.removeHandler(msg[1], mh);
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (hb_1_1 && !hb_1_1.done && (_a = hb_1.return)) _a.call(hb_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.emit('message', msg);
    };
    PodAdapter.prototype.pull = function () {
        var output = [];
        for (var i = this.stagedMessages.length - 1; i >= 0; i--) {
            var _a = __read(this.stagedMessages[i], 2), msg = _a[0], rk = _a[1];
            if (rk && this.reduceTracker.has(rk))
                continue;
            if (rk)
                this.reduceTracker.add(rk);
            output.push(msg);
        }
        logger.log('pull:', 'reduced', this.stagedMessages.length - output.length, 'and sending', output.length);
        this.reduceTracker.clear();
        this.stagedMessages.splice(0, this.stagedMessages.length);
        return output;
    };
    PodAdapter.prototype.request = function (arg0, arg1, arg2) {
        return __awaiter(this, void 0, void 0, function () {
            var outCode, inCode, data, tag, msg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof (arg0) === 'object') {
                            return [2 /*return*/, this.request(arg0.outCode, arg0.inCode, arg0.outData)];
                        }
                        outCode = arg0;
                        inCode = arg1;
                        data = arg2;
                        tag = "R".concat(this.nextTag());
                        this.stage([this.id, Codes_1.Codes[outCode], data, tag]);
                        return [4 /*yield*/, this.receiveReply(Codes_1.Codes[inCode], tag)];
                    case 1:
                        msg = _a.sent();
                        return [2 /*return*/, msg[2]];
                }
            });
        });
    };
    PodAdapter.prototype.send = function (outCode, data, reductionKey) {
        this.stage([this.id, Codes_1.Codes[outCode], data, null], reductionKey);
    };
    PodAdapter.prototype.receive = function (inCode, callback) {
        return this.addHandler(Codes_1.Codes[inCode], function (msg) {
            callback(msg[2]);
            return false;
        });
    };
    PodAdapter.prototype.nextTag = function () {
        this.currentTag++;
        return this.currentTag;
    };
    PodAdapter.prototype.stage = function (msg, reductionKey) {
        this.stagedMessages.push([msg, reductionKey]);
        if (this.stagedMessages.length === 1) {
            this.bridge.requestPull();
        }
    };
    PodAdapter.prototype.receiveReply = function (replyCode, tag) {
        var _this = this;
        return new Promise(function (rs, _rj) {
            _this.addHandler(replyCode, function (msg) {
                if (msg[3] === tag) {
                    rs(msg);
                    return true;
                }
                return false;
            });
        });
    };
    PodAdapter.prototype.addHandler = function (inCode, handler) {
        var _this = this;
        var _a;
        var hb = (_a = this.handlers[inCode]) !== null && _a !== void 0 ? _a : (this.handlers[inCode] = []);
        hb.push(handler);
        return function () { return _this.removeHandler(inCode, handler); };
    };
    PodAdapter.prototype.removeHandler = function (inCode, handler) {
        var hb = this.handlers[inCode];
        if (!hb)
            return;
        var i = hb.indexOf(handler);
        if (i < 0)
            return;
        hb.splice(i, 1);
    };
    return PodAdapter;
}(EventSourceBase_1.EventSourceBase));
exports.PodAdapter = PodAdapter;
